const Failed: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        d="M16.0005 2.66663C8.62717 2.66663 2.66718 8.62662 2.66718 16C2.66718 23.3733 8.62717 29.3333 16.0005 29.3333C23.3738 29.3333 29.3338 23.3733 29.3338 16C29.3338 8.62662 23.3738 2.66663 16.0005 2.66663ZM22.6672 20.7866L20.7872 22.6666L16.0005 17.88L11.2138 22.6666L9.33384 20.7866L14.1205 16L9.33384 11.2133L11.2138 9.33329L16.0005 14.12L20.7872 9.33329L22.6672 11.2133L17.8805 16L22.6672 20.7866Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Failed;
